import React, { useState, useEffect, useRef } from "react";
import "./Navbar.scss";

import logo from "../../assets/logo-2026.png";
import { useTranslation } from "react-i18next";
import { navbarItems } from "../../constants";
import { LanguageSwitcher } from "../LanguageSwitcher/LanguageSwitcher";

function Navbar() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen((open) => !open);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="navbar-container">
      <div className="navbar-language-desktop">
        <LanguageSwitcher className="language-switcher--desktop-nav" />
      </div>

      <nav className="navbar" aria-label="Main">
        <img src={logo} className="logo" alt="" />

        <ul className="navbar-menu">
          {navbarItems.map((item) => (
            <li key={item.id}>
              <a href={`/#${item.label}`}>{t(item.label)}</a>
            </li>
          ))}
        </ul>

        <div className="navbar-end">
          <div
            className={`hamburger-menu ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            ref={hamburgerRef}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleMenu();
              }
            }}
            aria-expanded={isMenuOpen}
            aria-label="Menu"
          >
            <div className="line" />
            <div className="line" />
            <div className="line" />
          </div>
        </div>
      </nav>

      <nav
        className={`navbar-mobile ${isMenuOpen ? "open" : ""}`}
        ref={menuRef}
        aria-hidden={!isMenuOpen}
      >
        <ul>
          {navbarItems.map((item) => (
            <li key={item.id}>
              <a href={`/#${item.label}`} onClick={closeMenu}>
                {t(item.label)}
              </a>
            </li>
          ))}
        </ul>
        <div className="language-switcher-mobile-wrap">
          <LanguageSwitcher className="language-switcher--desktop-nav" />
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
